namespace GeniuzPOS.AdvPromo {
    export namespace Adv05ItemExDTsService {
        export const baseUrl = 'AdvPromo/Adv05ItemExDTs';

        export declare function Create(request: Serenity.SaveRequest<Adv05ItemExDTsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<Adv05ItemExDTsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<Adv05ItemExDTsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<Adv05ItemExDTsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "AdvPromo/Adv05ItemExDTs/Create",
            Update = "AdvPromo/Adv05ItemExDTs/Update",
            Delete = "AdvPromo/Adv05ItemExDTs/Delete",
            Retrieve = "AdvPromo/Adv05ItemExDTs/Retrieve",
            List = "AdvPromo/Adv05ItemExDTs/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>Adv05ItemExDTsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
